var primary = localStorage.getItem('primary_color') || '#7366ff';
var secondary = localStorage.getItem('secondary_color') || '#9BE8D8';
export const  apexDashboard = {
  options: {
    chart: {
      height: 135,
      type: 'line',
      toolbar: {
        show: false
      },
      dropShadow: {
        enabled: true,
        enabledOnSeries: undefined,
        top: 5,
        left: 0,
        blur: 4,
        color: '#7366ff',
        opacity: 0.22
      },
    },
    markers: {
      size: 3,
      // colors: undefined,
      // strokeColors: '#fff',
      // strokeWidth: 2,
      // strokeOpacity: 0.9,
      // strokeDashArray: 0,
      // fillOpacity: 1,
      // discrete: [],
      // shape: "circle",
      // radius: 2,
      // offsetX: 0,
      // offsetY: 0,
      // onClick: undefined,
      // onDblClick: undefined,
      // showNullDataPoints: true,
      hover: {
        size: 4,
        // sizeOffset: 3
      }
    },
    grid: {
      yaxis: {
        lines: {
          show: false
        }
      },
    },
    colors: ["#5527FF"],
    stroke: {
      width: 3,
      curve: 'smooth'
    },
    xaxis: {
      type: 'category',
      tickAmount: 10,
      tickPlacement: 'on',
      //   min: 0,
      labels: {
        style: {
          fontFamily: 'Rubik, sans-serif',
        },
      },
      axisTicks: {
        //   show: false
        show: false
      },
      axisBorder: {
        show: false
      },
      tooltip: {
        enabled: false,
      },
      title: {
        text: 'Month',
        style: {
          fontFamily: 'Rubik, sans-serif',
        },
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        gradientToColors: ['#5527FF'],
        shadeIntensity: 1,
        type: 'horizontal',
        opacityFrom: 1,
        opacityTo: 1,
        colorStops: [{
            offset: 0,
            color: "#5527FF",
            opacity: 1
          },
          {
            offset: 100,
            color: "#E069AE",
            opacity: 1
          },
        ]
      },
    },
    yaxis: {
      min: 0,
      max: 4,
      labels: {
        show: true,
        //   formatter: function (value) {
        //     return value;
        //   }
      },
      title: {
        text: 'Score',
        style: {
          fontFamily: 'Rubik, sans-serif',
        },
      }
    },
    tooltip:{
      enabled: true,
      x:{
        show: false,
      }
    },
    responsive: [{
        breakpoint: 992,
        options: {
          chart: {
            height: 150,
          }
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 200,
          }
        },
      }
    ]
  }
}

export const  pieChart = {
  chart: {
    height: 380,
    type: 'donut',
  },
  responsive: [{
      breakpoint: 480,
      responsive: [{
        breakpoint: 480,
        options: {
            chart: {
                width: 200
            },
            legend: {
                position: 'bottom'
            }
        }
    }],
  }],
  colors: [primary, '#222222', '#222222', '#717171', '#e2c636', '#e2c636']
}